import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface Permiso {
  id?: number;
  name: string;
}

export interface Permisos {
    permisos: Permiso[];
}

export interface PermisosState {
  permisos: string[];
  error: boolean;
  debugMessage?: any;
}

export interface ObtenerListadoPermissionRequest {
  empresa: {
    id: number
  }
}

export interface ObtenerListadoPermissionResponse extends ResponseMessageWithInternalStatus{
  permissions: {
    id: number;
    name: string;
  }[]
}

export const initialPermisosState: PermisosState = {
  permisos: [],
  error: false,
  debugMessage: null
};